import AuthLayout from "../auth/AuthLayout";
import GamePage from "../pages/GamePage";
import Friends from "../pages/Friends";
import JackpotPage from "../pages/JackpotPage";
import MegaJackpotPage from "../pages/MegaJackpotPage";
import Rules from "../pages/Rules";
import Faq from "../pages/Faq";
import Profile from "../pages/Profile";
import Home from "../pages/Home";
import Quests from "../pages/Quests";
import RulesFaq from "../pages/RulesFaq";

interface RouteProps {
    path: string,
    component: any,
    exact?:boolean
}

export const allRoutes: Array<RouteProps> = [
    {path: "/", component: Home},
    { path: '/games', component: AuthLayout },
    { path: `/:gameName`, component: GamePage },
    { path: "/jackpot", component: JackpotPage },
    { path: "/mega-jackpot", component: MegaJackpotPage },
    { path: "/friends", component: Friends },
    { path: "/rules", component: Rules },
    { path: "/faq", component: Faq },
    { path: "/quests", component: Quests },
    { path: "/rules-faq", component: RulesFaq },
    { path: "/profile", component: Profile },
    { path: '*', component: "ErrorPage" }
]


